










































import mixins from 'vue-typed-mixins'
import LanguagePicker from '@/layout/components/LanguagePicker.vue'
import layoutMixin from '../layoutMixin'
import routeMixin from '@/router/routeMixin'
import Openable from '@/global/viewmodels/openable'
import globalMixin from '@/modules/globalMixin'

export default mixins(globalMixin, layoutMixin, routeMixin).extend({
    props: {
        drawer: Openable,
    },
    components: {
        LanguagePicker,
    },
})
